const MOEDA = new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const INTEIRO = new Intl.NumberFormat('pt-BR');

export function moeda(valor: number | null | undefined): string {
  return MOEDA.format(valor ?? 0);
}

/** Zero vira travessão: coluna densa cheia de "0,00" esconde o que importa. */
export function moedaOuTraco(valor: number | null | undefined): string {
  const v = valor ?? 0;
  return Math.abs(v) >= 0.005 ? MOEDA.format(v) : '—';
}

export function inteiro(valor: number | null | undefined): string {
  return INTEIRO.format(valor ?? 0);
}

export function percentual(valor: number | null | undefined): string {
  return `${MOEDA.format(valor ?? 0)}%`;
}

export function participacao(parte: number, total: number): string {
  if (!total) return '—';
  return percentual((parte / total) * 100);
}

/**
 * O contrato do tRPC declara `Date` porque o tipo vem do driver do MySQL, mas
 * sem transformer a resposta chega como string ISO. Aceita os dois.
 */
export function data(valor: Date | string | null | undefined): string {
  if (valor === null || valor === undefined) return '—';
  const iso = valor instanceof Date ? valor.toISOString().slice(0, 10) : String(valor).slice(0, 10);
  const partes = iso.split('-');
  if (partes.length !== 3) return iso || '—';
  return `${partes[2]}/${partes[1]}/${partes[0]}`;
}

export function dataHora(valor: Date | string | null | undefined): string {
  if (valor === null || valor === undefined) return '—';
  const d = valor instanceof Date ? valor : new Date(String(valor));
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
}

/** "2026-04" → "04/2026". */
export function competencia(valor: string | null | undefined): string {
  if (!valor) return '—';
  const partes = valor.split('-');
  if (partes.length < 2) return valor;
  return `${partes[1]}/${partes[0]}`;
}

export function numero(valor: number | null | undefined, casas = 2): string {
  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: casas,
  }).format(valor ?? 0);
}

export function plural(n: number, singular: string, plural_: string): string {
  return `${inteiro(n)} ${n === 1 ? singular : plural_}`;
}
